import classNames from "classnames/bind";
import styles from "./Brands.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClockRotateLeft,
    faCircleInfo,
    faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import BrandInfo from "~/components/Brands/BrandInfo/BrandInfo";
import CarOfBrand from "~/components/Brands/CarOfBrand/CarOfBrand";
import SideBrands from "~/components/Brands/SideBrands/SideBrands";
import BreadCrumb from "~/components/BreadCrumb/BreadCrumb";
import SliderHistory from "~/components/SliderHistory/SliderHistory";
import { Helmet } from "react-helmet";
import BlogSlide from "~/components/BlogSlide/BlogSlide";
const cx = classNames.bind(styles);
const Brands = ({ data }) => {
    console.log("cars");
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    window.scrollTo(0, 0);
    return (
        <div className={cx("wrap")}>
            <div className={cx("all")}>
                <Helmet>
                    <title>
                        Các thương hiệu siêu xe nổi tiếng - Supercar Universe
                    </title>
                    <meta
                        name="description"
                        content="Top các hãng sản suất siêu xe nhanh và đắt nhất thế giới"
                    />
                    <meta
                        name="keywords"
                        content={`Thương hiệu siêu xe, top siêu xe, siêu xe của`}
                    />
                </Helmet>
                <div className={cx("wrapper")}>
                    {mediaQuery && (
                        <div className={cx("bread_crumb")}>
                            <BreadCrumb data={data} />
                        </div>
                    )}
                    {!mediaQuery && (
                        <div className={cx("slider_mobile")}>
                            <div className={cx("cars_title")}>
                                <div>
                                    <i>
                                        <FontAwesomeIcon
                                            icon={faClockRotateLeft}
                                        />
                                    </i>{" "}
                                    <span> Xem gần đây</span>
                                </div>
                            </div>
                            <SliderHistory />
                            <div className={cx("cars_title")}>
                                <div>
                                    <i></i> <span>Các hãng xe</span>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className={cx("content")}>
                        {window.location.pathname !== "/brands" && (
                            <BrandInfo data={data} />
                        )}
                    </div>

                    {window.location.pathname !== "/brands" && (
                        <>
                            <div className={cx("cars_title", "oder_3")}>
                                <h3>Siêu xe {data.brand}</h3>{" "}
                            </div>
                            <div className={cx("cars_ofbrand")}>
                                <CarOfBrand data={data} />
                            </div>
                            <span className={cx("price")}>
                                <FontAwesomeIcon icon={faCircleInfo} /> &nbsp;
                                Giá chênh lệch do tỷ giá khác thời điểm hoặc có
                                thuế đặc biệt nếu xe về Việt Nam
                            </span>
                        </>
                    )}
                    {!mediaQuery && (
                        <>
                            {" "}
                            <div className={cx("side_blog")}>
                                <div className={cx("cars_title")}>
                                    <h3>Tin liên quan</h3>{" "}
                                    <p>
                                        Xem thêm
                                        <i>
                                            <FontAwesomeIcon
                                                icon={faAngleDoubleRight}
                                            />
                                        </i>{" "}
                                    </p>
                                </div>{" "}
                                <BlogSlide />
                            </div>
                        </>
                    )}

                    {!mediaQuery && <SideBrands />}
                </div>

                {mediaQuery && (
                    <>
                        {" "}
                        <br />
                        <div className={cx("cars_title")}>
                            <h3>Tin liên quan</h3>{" "}
                            <p>
                                Xem thêm tất cả tin hãng {data && data.brand}{" "}
                                <i>
                                    <FontAwesomeIcon
                                        icon={faAngleDoubleRight}
                                    />
                                </i>{" "}
                            </p>
                        </div>
                        <div className={cx("side_blog")}>
                            <BlogSlide />
                        </div>
                    </>
                )}
                {mediaQuery && (
                    <>
                        <div className={cx("cars_title")}>
                            <div>
                                <i>
                                    <FontAwesomeIcon icon={faClockRotateLeft} />
                                </i>{" "}
                                <span> Xem gần đây</span>
                            </div>
                        </div>
                        <div className={cx("des", "content")}>
                            <SliderHistory />
                        </div>
                    </>
                )}
                {!mediaQuery && (
                    <div className={cx("bread_crumb")}>
                        <BreadCrumb data={data} />
                    </div>
                )}
            </div>
            {mediaQuery && <SideBrands />}
        </div>
    );
};

export default Brands;
